import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assistance',
  templateUrl: './assistance.component.html',
  styleUrls: ['./assistance.component.scss']
})
export class AssistanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
